import React, { PureComponent } from "react";
import axios from "axios";
import { server, config, checkAccess } from "../env";
import Modal from "../components/Modal";
import Alert from "../components/Alert";
import Loader from "../components/Loader";
import { getCalculatedPrice, setThemeMode } from "../tools/helper";
import publicIp from "public-ip";

export default class Pricing extends PureComponent {
  state = {
    mode: localStorage.getItem("themeMode"),
    plans: [],
    payment_methods: [],
    message: "",
    loader: "",
    plan: "",
    isBilling: false,

    // Buy Additional GB state
    addGbMessage: "",

    // plans switch
    planType: "normal",

    // buy zenum plans
    activePlanIndex: 0,
    totalGBs: 50,
    addGbPricing: 0,
    minGB: 50,
    planPrice: 0,
    price: 0,
  };

  componentDidMount = async () => {
    this.setMode(this.state.mode);
    document.title = "Pricing - Proxies.gg";
    await axios
      .get(server + "/v1/billing/read", config)
      .then((rsp) => {
        this.setState({
          isBilling: true,
        });
      })
      .catch((err) => {
        document.getElementById("billingModal").click();
      });
    await axios
      .get(server + "/v1/payment_method/read", config)
      .then((rsp) => {
        this.setState({
          payment_methods: rsp.data.payload,
        });
      })
      .catch((err) => {
        checkAccess(err);
      });
    await axios.get(server + "/v1/plan/read").then((rsp) => {
      this.setState({
        plans: rsp.data.payload,
      });
    });
  };

  setMode = (mode) => {
    setThemeMode(mode);
    this.setState({
      mode,
    });
  };

  checkout = async (e) => {
    e.preventDefault();

    if (!this.state.isBilling) {
      document.getElementsByClassName("close")[0].click();
      document.getElementById("billingModal").click();
      return;
    }

    this.setState({
      loader: <Loader />,
    });

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});
    params.plan = this.state.plan;

    var payment_method = e.target.payment_method.value;

    payment_method = this.state.payment_methods.filter(
      (data) => data.id === parseInt(payment_method)
    )[0];

    await axios
      .post(server + "/v1/invoice/create", params, config)
      .then(async (rsp) => {
        window.location.href = rsp.data.payload.hosted_url;
        this.setState({
          message: <Alert className="success" message={rsp.data.detail} />,
          loader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            message: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          loader: "",
        });
      });
  };

  normalCheckout = async (e) => {
    e.preventDefault();

    if (!this.state.isBilling) {
      document.getElementsByClassName("close")[0].click();
      document.getElementById("billingModal").click();
      return;
    }

    this.setState({
      loader: <Loader />,
    });

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});
    params.plan = this.state.plan;
    params.gb = this.state.totalGBs;

    await axios
      .post(server + "/v1/invoice/create-normal", params, config)
      .then(async (rsp) => {
        window.location.href = rsp.data.payload.hosted_url;
        this.setState({
          message: <Alert className="success" message={rsp.data.detail} />,
          loader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            message: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          loader: "",
        });
      });
  };

  billing = async (e) => {
    e.preventDefault();
    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});

    this.setState({
      billingLoader: <Loader />,
    });

    try {
      params.ip = await publicIp.v4();
    } catch (err) {
      params.ip = await publicIp.v6();
    }

    await axios
      .post(server + "/v1/billing/create", params, config)
      .then((rsp) => {
        this.setState({
          isBilling: true,
          billingLoader: "",
        });
        document.getElementsByClassName("close")[1].click();
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            billingMessage: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          billingLoader: "",
        });
      });
  };

  buyAdditionalGb = async (e) => {
    e.preventDefault();

    if (!this.state.isBilling) {
      document.getElementsByClassName("close")[0].click();
      document.getElementById("billingModal").click();
      return;
    }

    this.setState({
      loader: <Loader />,
      addGbMessage: "",
    });

    var params = Array.from(e.target.elements)
      .filter((el) => el.name)
      .reduce((a, b) => ({ ...a, [b.name]: b.value }), {});
    params.plan = this.state.plan;
    params.plan_type = this.state.planType;

    var payment_method = e.target.payment_method.value;

    payment_method = this.state.payment_methods.filter(
      (data) => data.id === parseInt(payment_method)
    )[0];

    await axios
      .post(server + "/v1/invoice/buyAdditional", params, config)
      .then(async (rsp) => {
        window.location.href = rsp.data.payload.hosted_url;
        this.setState({
          addGbMessage: <Alert className="success" message={rsp.data.detail} />,
          loader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            addGbMessage: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          loader: "",
        });
      });
  };

  render() {
    const { plans, payment_methods } = this.state;
    const { message, loader } = this.state;
    const { billingMessage, billingLoader } = this.state;
    const { addGbMessage } = this.state;
    const { planType } = this.state;
    const { activePlanIndex, totalGBs, planPrice, price, addGbPricing, minGB } =
      this.state;

    return (
      <div className="main-content">
        <div className="pt-7 pb-8 bg-dark bg-ellipses">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-6">
                <h1 className="display-3 text-center text-white">
                  Plans & Pricing
                </h1>

                <p className="lead text-center text-muted">
                  We have plans and prices that fit your business perfectly.
                  Make your client site a success with our products.
                </p>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row justify-content-between">
              <div className="col-auto">
                <div
                  className={
                    planType === "normal"
                      ? "btn btn-primary me-3"
                      : "btn btn-outline-primary me-3"
                  }
                  onClick={() =>
                    this.setState({
                      planType: "normal",
                    })
                  }
                >
                  Normal Plans
                </div>
                <div
                  className={
                    planType === "premium"
                      ? "btn btn-primary"
                      : "btn btn-outline-primary"
                  }
                  onClick={() =>
                    this.setState({
                      planType: "premium",
                    })
                  }
                >
                  Premium Plans
                </div>
              </div>
              <div className="col-auto">
                <div
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#buyAdditionalGb"
                >
                  Buy Additional GB
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row mt-n7">
            {plans.map((plan, index) =>
              planType === "premium" ? (
                plan.type === "PR_2" ? (
                  <div className="col-12 col-lg-4" key={index}>
                    <div className="card">
                      <div className="card-body">
                        <h6 className="text-uppercase text-center text-muted my-4">
                          {plan.name}
                        </h6>

                        <div className="row g-0 align-items-center justify-content-center">
                          <div className="col-auto">
                            <div className="display-2 mb-0">
                              {(plan.price * plan.data).toFixed(2)}
                            </div>
                          </div>
                          <div className="col-auto">
                            <div className="h2 mb-0">€</div>
                          </div>
                        </div>

                        <div className="h6 text-uppercase text-center text-muted mb-5">
                          / month
                        </div>

                        <div className="mb-3">
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                              <small>
                                {plan.add_gb_price.toFixed(2)}€ / GB
                              </small>
                              <i className="fe fe-check-circle text-success"></i>
                            </li>
                            <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                              <small>150+ Countries</small>{" "}
                              <i className="fe fe-check-circle text-success"></i>
                            </li>
                            <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                              <small>Unlimited Threads</small>{" "}
                              <i className="fe fe-check-circle text-success"></i>
                            </li>
                            <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                              <small>{plan.data} GB data included</small>
                              <i className="fe fe-check-circle text-success"></i>
                            </li>
                            <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                              <small>
                                {plan.add_gb_price.toFixed(2)}€ Per Additional
                                GB
                              </small>
                              <i className="fe fe-check-circle text-success"></i>
                            </li>
                            <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                              <small> 24/7 Support</small>
                              <i className="fe fe-check-circle text-success"></i>
                            </li>
                          </ul>
                        </div>

                        <a
                          href="#!"
                          className="btn w-100 btn-primary"
                          onClick={() => this.setState({ plan: plan.id })}
                          data-bs-toggle="modal"
                          data-bs-target="#checkout"
                        >
                          Buy Now
                        </a>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : plan.type === "PR_1" ||
                plan.type === "PR_2" ||
                plan.type === "PR_3" ? (
                ""
              ) : (
                <div className="col-12 col-lg-4" key={index}>
                  <div className="card">
                    <div className="card-body">
                      <h6 className="text-uppercase text-center text-muted my-4">
                        {plan.name}
                      </h6>

                      <div className="row g-0 align-items-center justify-content-center">
                        <div className="col-auto">
                          <div className="display-2 mb-0">
                            {(plan.price * plan.data).toFixed(2)}
                          </div>
                        </div>
                        <div className="col-auto">
                          <div className="h2 mb-0">€</div>
                        </div>
                      </div>

                      <div className="h6 text-uppercase text-center text-muted mb-5">
                        / month
                      </div>

                      <div className="mb-3">
                        <ul className="list-group list-group-flush">
                          <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                            <small>{plan.add_gb_price.toFixed(2)}€ / GB</small>
                            <i className="fe fe-check-circle text-success"></i>
                          </li>
                          <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                            <small>150+ Countries</small>{" "}
                            <i className="fe fe-check-circle text-success"></i>
                          </li>
                          <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                            <small>Unlimited Threads</small>{" "}
                            <i className="fe fe-check-circle text-success"></i>
                          </li>
                          <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                            <small>{plan.data} GB data included</small>
                            <i className="fe fe-check-circle text-success"></i>
                          </li>
                          <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                            <small>
                              {plan.add_gb_price.toFixed(2)}€ Per Additional GB
                            </small>
                            <i className="fe fe-check-circle text-success"></i>
                          </li>
                          <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                            <small> 24/7 Support</small>
                            <i className="fe fe-check-circle text-success"></i>
                          </li>
                        </ul>
                      </div>

                      <a
                        href="#!"
                        className="btn w-100 btn-primary"
                        onClick={() => this.setState({ plan: plan.id })}
                        data-bs-toggle="modal"
                        data-bs-target="#checkout"
                      >
                        Buy Now
                      </a>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
          <div className="row mt-n7">
            {planType === "normal" && plans.length > 0
              ? plans
                  .filter((data, index) => data.type === "PR_3")
                  .sort((a, b) => {
                    return parseFloat(a.price) - parseFloat(b.price);
                  })
                  .splice(1, 3)
                  .map((plan, index) => (
                    <div className="col-12 col-lg-4 mt-4">
                      <div className="card">
                        <div className="card-body">
                          <h6 className="text-uppercase text-center text-muted my-4">
                            {plan.name}
                          </h6>

                          <div className="row g-0 align-items-center justify-content-center">
                            <div className="col-auto">
                              <div className="display-2 mb-0">
                                {plan.price.toFixed(2)}
                              </div>
                            </div>
                            <div className="col-auto">
                              <div className="h2 mb-0">€</div>
                            </div>
                          </div>

                          <div className="h6 text-uppercase text-center text-muted mb-5">
                            / {plan.name.replaceAll("1 ", "")}
                          </div>

                          <div className="mb-3">
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>Worldwide locations</small>{" "}
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>
                                  {plan.data}GB Included ({plan.add_gb_price}
                                  €/50GB)
                                </small>{" "}
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>Unlimited threads</small>
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>HTTP/s & SOCKS5 Support</small>
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small> 24/7 Support</small>
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                            </ul>
                          </div>

                          <a
                            href="#!"
                            className="btn w-100 btn-primary"
                            // onClick={() => this.setState({ plan: plan.id })}
                            data-bs-toggle="modal"
                            data-bs-target="#checkout2"
                            onClick={() =>
                              this.setState({
                                totalGBs: plan.name.includes("Month")
                                  ? 150
                                  : plan.name.includes("Week")
                                  ? 100
                                  : 50,
                                plan: plan.id,
                                activePlanIndex: index + 1,
                                addGbPricing: plan.add_gb_price,
                                planPrice: plan.price,
                                minGB: plan.name.includes("Month")
                                  ? 150
                                  : plan.name.includes("Week")
                                  ? 100
                                  : 50,
                                price: plan.price,
                              })
                            }
                          >
                            Buy Now
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
              : ""}
          </div>
          <div className="row">
            {planType === "normal" && plans.length > 0
              ? plans
                  .filter((data, index) => data.type === "PR_3")
                  .sort((a, b) => {
                    return parseFloat(a.price) - parseFloat(b.price);
                  })
                  .splice(0, 1)
                  .map((plan, index) => (
                    <div className="col-12 mt-4">
                      <div className="card">
                        <div className="card-body">
                          <h6 className="text-uppercase text-center text-muted my-4">
                            {plan.name}
                          </h6>

                          <div className="row g-0 align-items-center justify-content-center">
                            <div className="col-auto">
                              <div className="display-2 mb-0">
                                {plan.price.toFixed(2)}
                              </div>
                            </div>
                            <div className="col-auto">
                              <div className="h2 mb-0">€</div>
                            </div>
                          </div>

                          <div className="h6 text-uppercase text-center text-muted mb-5">
                            / {plan.name.replaceAll("1 ", "")}
                          </div>

                          <div className="mb-3">
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>Worldwide locations</small>{" "}
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>Unlimited Threads</small>
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>Unlimited Bandwidth</small>
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                              <li className="list-group-item d-flex align-items-center justify-content-between px-0">
                                <small>HTTP/s & SOCKS5 Support</small>
                                <i className="fe fe-check-circle text-success"></i>
                              </li>
                            </ul>
                          </div>

                          <a
                            href="#!"
                            className="btn w-100 btn-primary"
                            // onClick={() => this.setState({ plan: plan.id })}
                            data-bs-toggle="modal"
                            data-bs-target="#checkout2"
                            onClick={() =>
                              this.setState({
                                totalGBs: plan.name.includes("Month")
                                  ? 150
                                  : plan.name.includes("Week")
                                  ? 100
                                  : 50,
                                plan: plan.id,
                                activePlanIndex: index,
                                addGbPricing: plan.add_gb_price,
                                planPrice: plan.price,
                                minGB: plan.name.includes("Month")
                                  ? 150
                                  : plan.name.includes("Week")
                                  ? 100
                                  : 50,
                                price: plan.price,
                              })
                            }
                          >
                            Buy Now
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
              : ""}
          </div>
          <button
            className="hide d-none"
            data-bs-toggle="modal"
            data-bs-target="#billing"
            id="billingModal"
          ></button>
        </div>

        {/* checkout modal */}
        <Modal id="checkout" title="Purchase">
          <div className="modal-body">
            <form onSubmit={this.checkout}>
              {message}
              <div className="form-group">
                <label htmlFor="payment">Select Payment Method</label>
                <select
                  name="payment_method"
                  id="method"
                  className="form-control"
                  required
                >
                  {payment_methods.map((pm, index) => (
                    <option value={pm.id}>{pm.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="payment">Promo Code (optional)</label>
                <input
                  type="text"
                  name="coupon"
                  id="coupon"
                  className="form-control"
                  placeholder="Enter promo code here"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary w-100">
                  Checkout {loader}
                </button>
              </div>
            </form>
          </div>
        </Modal>

        {/* checkout 2 modal */}
        <Modal id="checkout2" title="Purchase">
          <div className="modal-body">
            <form onSubmit={this.normalCheckout}>
              {message}
              <div className="form-group">
                <label htmlFor="payment">Select Payment Method</label>
                <select
                  name="payment_method"
                  id="method"
                  className="form-control"
                  required
                >
                  {payment_methods.map((pm, index) => (
                    <option value={pm.id}>{pm.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="payment">Promo Code (optional)</label>
                <input
                  type="text"
                  name="coupon"
                  id="coupon"
                  className="form-control"
                  placeholder="Enter promo code here"
                />
              </div>

              {activePlanIndex === 0 ? (
                <div className="form-group">
                  <div className="row justify-content-between">
                    <div className="col-auto">
                      <label htmlFor="payment">Unlimited Bandwidth</label>
                    </div>
                  </div>
                  <input
                    type="range"
                    name="gb"
                    min="50"
                    max="2000"
                    className="form-range d-none"
                    onChange={(e) =>
                      this.setState({
                        totalGBs: 50,
                      })
                    }
                    step="50"
                    id="range"
                  />
                </div>
              ) : (
                <div className="form-group">
                  <label htmlFor="payment">{totalGBs} GB</label>
                  <input
                    type="range"
                    name="gb"
                    min={minGB}
                    max="2000"
                    className="form-range"
                    onChange={(e) =>
                      this.setState({
                        totalGBs: e.target.value,
                        price:
                          activePlanIndex === 0
                            ? price
                            : getCalculatedPrice(
                                planPrice,
                                parseInt(e.target.value),
                                addGbPricing,
                                activePlanIndex
                              ).toFixed(2),
                      })
                    }
                    step="50"
                    id="range"
                  />
                </div>
              )}

              <div className="form-group">
                <button type="submit" className="btn btn-primary w-100">
                  Checkout {price}€ {loader}
                </button>
              </div>
            </form>
          </div>
        </Modal>

        {/* additional gb checkout modal */}
        <Modal id="buyAdditionalGb" title="Purchase">
          <div className="modal-body">
            <form onSubmit={this.buyAdditionalGb}>
              {addGbMessage}
              <div className="form-group">
                <label htmlFor="payment">Select Payment Method</label>
                <select
                  name="payment_method"
                  id="method"
                  className="form-control"
                  required
                >
                  {payment_methods.map((pm, index) => (
                    <option value={pm.id}>{pm.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="payment">GB</label>
                <input
                  type="number"
                  name="amount"
                  id="amount"
                  className="form-control"
                  placeholder="Enter GBs amount here"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="payment">Promo Code (optional)</label>
                <input
                  type="text"
                  name="coupon"
                  id="coupon"
                  className="form-control"
                  placeholder="Enter promo code here"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary w-100">
                  Checkout {loader}
                </button>
              </div>
            </form>
          </div>
        </Modal>

        {/* Billing Modal */}
        <Modal id="billing" title="Billing Details">
          <div className="modal-body">
            <form onSubmit={this.billing}>
              {billingMessage}
              <div className="form-group">
                <label htmlFor="f_name">First Name</label>
                <input
                  type="text"
                  name="first_name"
                  id="first_name"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="l_name">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  id="last_name"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  name="address"
                  id="address"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">City</label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="zip">Zip Code</label>
                <input
                  type="text"
                  name="zip"
                  id="zip"
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="country">Country</label>
                <select
                  type="text"
                  name="country"
                  id="country"
                  className="form-control"
                  required
                >
                  <option value="">Select Country</option>
                  <option value="United States">United States</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Afghanistan">Afghanistan</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="American Samoa">American Samoa</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguilla">Anguilla</option>
                  <option value="Antarctica">Antarctica</option>
                  <option value="Antigua and Barbuda">
                    Antigua and Barbuda
                  </option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bermuda">Bermuda</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bosnia and Herzegovina">
                    Bosnia and Herzegovina
                  </option>
                  <option value="Botswana">Botswana</option>
                  <option value="Bouvet Island">Bouvet Island</option>
                  <option value="Brazil">Brazil</option>
                  <option value="British Indian Ocean Territory">
                    British Indian Ocean Territory
                  </option>
                  <option value="Brunei Darussalam">Brunei Darussalam</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Cape Verde">Cape Verde</option>
                  <option value="Cayman Islands">Cayman Islands</option>
                  <option value="Central African Republic">
                    Central African Republic
                  </option>
                  <option value="Chad">Chad</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Christmas Island">Christmas Island</option>
                  <option value="Cocos (Keeling) Islands">
                    Cocos (Keeling) Islands
                  </option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo">Congo</option>
                  <option value="Congo, The Democratic Republic of The">
                    Congo, The Democratic Republic of The
                  </option>
                  <option value="Cook Islands">Cook Islands</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Cote D'ivoire">Cote D'ivoire</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Falkland Islands (Malvinas)">
                    Falkland Islands (Malvinas)
                  </option>
                  <option value="Faroe Islands">Faroe Islands</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="French Guiana">French Guiana</option>
                  <option value="French Polynesia">French Polynesia</option>
                  <option value="French Southern Territories">
                    French Southern Territories
                  </option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Greece">Greece</option>
                  <option value="Greenland">Greenland</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guadeloupe">Guadeloupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guinea-bissau">Guinea-bissau</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Heard Island and Mcdonald Islands">
                    Heard Island and Mcdonald Islands
                  </option>
                  <option value="Holy See (Vatican City State)">
                    Holy See (Vatican City State)
                  </option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="India">India</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="Iran, Islamic Republic of">
                    Iran, Islamic Republic of
                  </option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Korea, Democratic People's Republic of">
                    Korea, Democratic People's Republic of
                  </option>
                  <option value="Korea, Republic of">Korea, Republic of</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Lao People's Democratic Republic">
                    Lao People's Democratic Republic
                  </option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libyan Arab Jamahiriya">
                    Libyan Arab Jamahiriya
                  </option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Macao">Macao</option>
                  <option value="North Macedonia">North Macedonia</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Martinique">Martinique</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Micronesia, Federated States of">
                    Micronesia, Federated States of
                  </option>
                  <option value="Moldova, Republic of">
                    Moldova, Republic of
                  </option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montserrat">Montserrat</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Namibia">Namibia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherlands">Netherlands</option>
                  <option value="Netherlands Antilles">
                    Netherlands Antilles
                  </option>
                  <option value="New Caledonia">New Caledonia</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Norfolk Island">Norfolk Island</option>
                  <option value="Northern Mariana Islands">
                    Northern Mariana Islands
                  </option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau">Palau</option>
                  <option value="Palestinian Territory, Occupied">
                    Palestinian Territory, Occupied
                  </option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Philippines">Philippines</option>
                  <option value="Pitcairn">Pitcairn</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Reunion">Reunion</option>
                  <option value="Romania">Romania</option>
                  <option value="Russian Federation">Russian Federation</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="Saint Helena">Saint Helena</option>
                  <option value="Saint Kitts and Nevis">
                    Saint Kitts and Nevis
                  </option>
                  <option value="Saint Lucia">Saint Lucia</option>
                  <option value="Saint Pierre and Miquelon">
                    Saint Pierre and Miquelon
                  </option>
                  <option value="Saint Vincent and The Grenadines">
                    Saint Vincent and The Grenadines
                  </option>
                  <option value="Samoa">Samoa</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome and Principe">
                    Sao Tome and Principe
                  </option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Serbia and Montenegro">
                    Serbia and Montenegro
                  </option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="South Georgia and The South Sandwich Islands">
                    South Georgia and The South Sandwich Islands
                  </option>
                  <option value="Spain">Spain</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Svalbard and Jan Mayen">
                    Svalbard and Jan Mayen
                  </option>
                  <option value="Swaziland">Swaziland</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syrian Arab Republic">
                    Syrian Arab Republic
                  </option>
                  <option value="Taiwan, Province of China">
                    Taiwan, Province of China
                  </option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania, United Republic of">
                    Tanzania, United Republic of
                  </option>
                  <option value="Thailand">Thailand</option>
                  <option value="Timor-leste">Timor-leste</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad and Tobago">
                    Trinidad and Tobago
                  </option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Turks and Caicos Islands">
                    Turks and Caicos Islands
                  </option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Emirates">
                    United Arab Emirates
                  </option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="United States">United States</option>
                  <option value="United States Minor Outlying Islands">
                    United States Minor Outlying Islands
                  </option>
                  <option value="Uruguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Viet Nam">Viet Nam</option>
                  <option value="Virgin Islands, British">
                    Virgin Islands, British
                  </option>
                  <option value="Virgin Islands, U.S.">
                    Virgin Islands, U.S.
                  </option>
                  <option value="Wallis and Futuna">Wallis and Futuna</option>
                  <option value="Western Sahara">Western Sahara</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary w-100">
                  Checkout {billingLoader}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    );
  }
}
